const ExternalRoutes = {

    path: '/app',
    // component: () => import('@/layouts/full/FullLayout.vue'),
    meta: {
        requiresAuth: false
    },
    children: [
        {
            name: 'Ticket Discussion',
            path: 'ticket/discussion/:id',
            component: () => import('@/layouts/blank/ExternalTicketUi.vue')
        },
        {
            name: 'Online Application',
            path: 'application/start',
            component: () => import('@/layouts/blank/ExternalOnlineApplicationUi.vue')
        },
        {
            name: 'Create Ticket',
            path: 'ticket/create',
            component: () => import('@/layouts/blank/ExtermalCreateTicketUi.vue')
        },
        {
            name: 'upload-recommendation-form',
            path: 'recommendation',
            component: () => import('@/layouts/blank/ExternalRecommendationForm.vue')
        },
        // Hidden: the public results page lists applicant names, colleges and
        // acceptance remarks on an unauthenticated route. Disabled pending a
        // decision on whether this data should be publicly accessible.
        // {
        //     name: 'application-results',
        //     path: '/result',
        //     component: () => import('@/views/results/Index.vue')
        // }

    ],
   

};

export default ExternalRoutes;